import { useEffect, useRef, useState } from "react";

/** A menu hanging from its button's end or start corner, growing out of that corner. */
const POP = "pop absolute z-30 mt-1 border border-line bg-surface shadow-lg";
export const POP_END = `${POP} end-0 ltr:origin-top-right rtl:origin-top-left`;
export const POP_START = `${POP} start-0 ltr:origin-top-left rtl:origin-top-right`;

/**
 * Open state for a menu under a button: a click outside the wrapper (ref) or Esc closes it,
 * and Esc hands focus back to the wrapper's first button.
 */
export function usePopover<T extends HTMLElement = HTMLDivElement>() {
  const [open, setOpen] = useState(false);
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!open) return;
    const onDown = (e: PointerEvent) => {
      if (!ref.current?.contains(e.target as Node)) setOpen(false);
    };
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== "Escape") return;
      setOpen(false);
      ref.current?.querySelector<HTMLElement>("button")?.focus();
    };
    document.addEventListener("pointerdown", onDown);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("pointerdown", onDown);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);
  return { open, setOpen, ref };
}
